import LegalLayout from "@/components/legal/LegalLayout";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
    return (
        <LegalLayout
            testId="privacy-policy-page"
            eyebrow="Legal · Privacy"
            title="Privacy Policy"
            updated="June 2026"
        >
            <section>
                <p>
                    Nicholas Kraus Consulting LLC (&ldquo;Nicholas Kraus Consulting,&rdquo;
                    &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy. This Privacy
                    Policy explains what information we collect, how we use it,
                    how it is protected, and the choices you have regarding your
                    information when you visit{" "}
                    <a
                        href="https://nicholaskrausconsulting.com"
                        className="text-gold hover:text-gold-light"
                    >
                        nicholaskrausconsulting.com
                    </a>{" "}
                    or otherwise engage with us.
                </p>
            </section>

            <h2>Information We Collect</h2>
            <p>
                We may collect and store personally identifiable information you
                choose to provide, including your name, mailing address, phone
                number, mobile phone number, e-mail address, username, campaign
                information, and any other information you submit to us through
                our website, forms, phone calls, or correspondence.
            </p>

            <h2>Text Messaging &amp; Mobile Opt-In</h2>
            <p>
                If you sign up to receive text messages from us, we will use
                your mobile phone number to send you text message updates from
                Nicholas Kraus Consulting. We may also collect, store, and use
                your mobile phone number to send you other text messages from
                Nicholas Kraus Consulting.
            </p>
            <p>
                We will also collect and store other personally identifiable
                information, such as your name, address, phone number, mobile
                phone number, e-mail address, username, and/or similar
                information you may choose to provide to us. In addition, we
                may share this information with our affiliates, partners, and
                other organizations or entities.
            </p>
            <p className="callout">
                <strong>
                    However, text messaging originator opt-in data and consent
                    will not be shared with any non-associated and/or
                    non-related third-party individual, brand, or entity except
                    for with vendors, consultants, and other service providers
                    who need access to such information to carry out work on
                    our behalf (and who will not use such information for their
                    own purposes).
                </strong>
            </p>
            <p className="callout">
                <strong>
                    No mobile opt-in information will be shared with third
                    parties for marketing purposes.
                </strong>
            </p>

            <h2>We Do Not Sell Your Data</h2>
            <p className="callout">
                <strong>
                    Nicholas Kraus Consulting does not sell, rent, or lease
                    user data to third parties.
                </strong>{" "}
                Any information we collect is used solely to provide our
                services, communicate with you, and improve our operations.
            </p>

            <h2>How We Use Your Information</h2>
            <ul>
                <li>To respond to inquiries and provide consulting services.</li>
                <li>To send campaign updates, event information, and news via email or text (only if you have opted in).</li>
                <li>To improve our website and services.</li>
                <li>To comply with legal obligations.</li>
            </ul>

            <h2>Cookies &amp; Analytics</h2>
            <p>
                Our website may use cookies and standard web analytics tools to
                understand how visitors use the site. These tools may collect
                anonymized data such as IP address, browser type, referring
                pages, and pages visited. This information helps us improve
                the site and is not used to identify individual visitors.
            </p>

            <h2>Data Security</h2>
            <p>
                We take reasonable technical and organizational measures to
                protect the information you provide against loss, misuse,
                unauthorized access, disclosure, alteration, or destruction.
                However, no method of transmission over the Internet or
                electronic storage is 100% secure, and we cannot guarantee
                absolute security.
            </p>

            <h2>Your Choices</h2>
            <p>
                You may opt out of text messages at any time by replying{" "}
                <strong>STOP</strong> to any text message we send you. You may
                unsubscribe from emails using the unsubscribe link in any email
                we send you. To request that we delete or update your personal
                information, contact us at the email or phone number below.
            </p>

            <h2>Children&apos;s Privacy</h2>
            <p>
                Our services are not directed to children under 13, and we do
                not knowingly collect personal information from children under
                13. If you believe we have collected information from a child
                under 13, please contact us and we will delete it.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. When we
                do, we will update the &ldquo;Last updated&rdquo; date at the top of this
                page. Continued use of our website after changes are posted
                constitutes acceptance of the updated policy.
            </p>

            <h2>Contact Us</h2>
            <p>
                Nicholas Kraus Consulting LLC
                <br />
                Email:{" "}
                <a
                    href="mailto:nrkraus@nicholaskrausconsulting.com"
                    className="text-gold hover:text-gold-light"
                >
                    nrkraus@nicholaskrausconsulting.com
                </a>
                <br />
                Phone:{" "}
                <a
                    href="tel:+19373213576"
                    className="text-gold hover:text-gold-light"
                >
                    937-321-3576
                </a>
            </p>

            <p className="mt-10">
                See also our{" "}
                <Link
                    to="/terms"
                    data-testid="privacy-terms-link"
                    className="text-gold hover:text-gold-light underline"
                >
                    Terms &amp; Conditions
                </Link>
                .
            </p>
        </LegalLayout>
    );
}
